import { isPstFileAccountInfraEnabled } from 'owa-account-source-list/lib/flights';
import { isCoprincipalMailbox } from 'owa-account-source-list-store';
import { getIsCustomSortEnabled } from '../selectors/getIsCustomSortEnabled';
import { getFoldersToShowFirst } from 'owa-folders-data-utils';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { getIndexerValueForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import { getRootFolderForMailboxInfo, getFolderByDistinguishedId } from './folderUtility';
import getPrimaryFolderTreeRootFolder from '../selectors/getPrimaryFolderTreeRootFolder';

/**
 * get all child folders of a mailbox
 * @return child folder ids
 */
export function getMailRootFolderChildIds(mailboxInfo: MailboxInfo): string[] {
    const rootFolder = getRootFolderForMailboxInfo(mailboxInfo);
    const folderIndexer = getIndexerValueForMailboxInfo(mailboxInfo);
    const isCustomSortEnabled = getIsCustomSortEnabled(mailboxInfo);
    const foldersToShowFirst = isCustomSortEnabled ? [] : getFoldersToShowFirst(mailboxInfo);
    const isPrimaryMailbox = isPstFileAccountInfraEnabled()
        ? isCoprincipalMailbox(mailboxInfo)
        : mailboxInfo.type == 'UserMailbox';
    let childFolderIds: string[] = [];

    // First add all the special folders if mailbox is primary and moveto context is primary
    if (
        rootFolder &&
        isPrimaryMailbox &&
        rootFolder.distinguishedFolderType ==
            getPrimaryFolderTreeRootFolder(mailboxInfo)?.distinguishedFolderType &&
        rootFolder.id // FolderId may be undefined if we fail to load data for folder hierarchy from session data.
    ) {
        const folders = foldersToShowFirst
            .map(distinguishedId => getFolderByDistinguishedId(distinguishedId, mailboxInfo))
            .filter(folder => folder && folder.parentFolderId === rootFolder?.id);

        childFolderIds = folderIndexer
            ? folders
                  .filter(
                      folder =>
                          folder?.mailboxInfo &&
                          getIndexerValueForMailboxInfo(folder?.mailboxInfo) === folderIndexer
                  )
                  .map(folder => folder?.id ?? '')
            : folders.map(folder => folder?.id ?? '');
    }

    // Get child folder ids for root folder that can be displayed to user
    // Root folders are unique per account, so are their childrenFolderIds
    const childFolderIdsThatCanBeDisplayed = rootFolder?.childFolderIds ?? [];

    // Add all the remaining folders that are not part of the special list above.
    for (let i = 0; i < childFolderIdsThatCanBeDisplayed.length; i++) {
        const childFolderId = childFolderIdsThatCanBeDisplayed[i];
        if (childFolderId && foldersToShowFirst.indexOf(folderIdToName(childFolderId)) === -1) {
            childFolderIds.push(childFolderId);
        }
    }

    return childFolderIds;
}
